// extracted by mini-css-extract-plugin
export default {"clarification":"ForgotPassPage_clarification__4ESRS","link":"ForgotPassPage_link__VfOpU"};